import './App.css';
import Page0 from './components/Page0';
import Page1 from './components/Page1';
import Page2 from './components/Page2';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';  

function App() {
  return (
    <Router>  
      <Routes>  
        <Route path="/" element={<Page0 />} />  
        <Route path="/somepage" element={<Page1/>} />  
        <Route path="/friends" element={<Page2 />} /> 

        {/* 添加 Route 来匹配其他页面 */}  
      </Routes>  
    </Router>  
  );
}

export default App;
